import './scss/main.scss';
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

import App from './App.vue'
import router from './router'
import store from './store'
import services from './services';

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.config.productionTip = false

Vue.prototype.$services = services;

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
